import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TemplateAssignmentClearFailedAction = {
	type: 'TEMPLATE_ASSIGNMENT_CLEAR_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TemplateAssignmentClearFailedAction => ({
	type: 'TEMPLATE_ASSIGNMENT_CLEAR_FAILED',
	payload,
});
